// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

const getPageParam = (pageIndex) => (pageIndex ? `?page=${pageIndex}` : '');

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    projects: path(ROOTS_DASHBOARD, '/projects'),
    createProject: path(ROOTS_DASHBOARD, '/project/new'),

    projectReport: (projectId) => path(ROOTS_DASHBOARD, `/project/${projectId}/report`),

    editProject: (projectId) => path(ROOTS_DASHBOARD, `/project/edit/${projectId}`),

    configLayout: (projectId) => path(ROOTS_DASHBOARD, `/project/${projectId}/config-layout`),

    configProfile: (projectId) => path(ROOTS_DASHBOARD, `/project/${projectId}/config-profile`),

    mediaCooperation: () => path(ROOTS_DASHBOARD, `/media-cooperation`),
    configSidebar: (projectId) => path(ROOTS_DASHBOARD, `/project/${projectId}/config-sidebar`),
    configNavbar: (projectId) => path(ROOTS_DASHBOARD, `/project/${projectId}/config-navbar`),
    configFooter: (projectId) => path(ROOTS_DASHBOARD, `/project/${projectId}/config-footer`),

    projectFeedList: (projectId, appSectionKeyOrder, appSectionId, pageIndex) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/${appSectionKeyOrder}/${appSectionId}/feeds${getPageParam(pageIndex)}`),

    createFeedProject: (projectId, appSectionKeyOrder, appSectionId) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/${appSectionKeyOrder}/${appSectionId}/feeds/new-feed`),

    editFeedProject: (projectId, appSectionKeyOrder, appSectionId, feedId) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/${appSectionKeyOrder}/${appSectionId}/feeds/${feedId}/edit-feed`),

    wheelList: (projectId) => path(ROOTS_DASHBOARD, `/project/${projectId}/wheels`),

    mediaRewards: (projectId) => path(ROOTS_DASHBOARD, `/project/${projectId}/mediaRewards`),

    wheelItemList: (projectId, wheelId) => path(ROOTS_DASHBOARD, `/project/${projectId}/wheels/${wheelId}/wheel-items`),

    feedItems: (projectId, appSectionKeyOrder, appSectionId, feedId, pageIndex) =>
      path(
        ROOTS_DASHBOARD,
        `/project/${projectId}/${appSectionKeyOrder}/${appSectionId}/feeds/${feedId}/feed-items${getPageParam(pageIndex)}`
      ),

    createFeedItem: (projectId, appSectionKeyOrder, feedId) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/${appSectionKeyOrder}feeds/${feedId}/feed-items/new-feed-item`),

    editFeedItem: (projectId, appSectionKeyOrder, feedId, feedItemId) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/${appSectionKeyOrder}/feeds/${feedId}/feed-items/${feedItemId}/edit-feed-item`),

    mediaSocialPlayerList: (projectId, pageIndex) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/media-social-player-list${getPageParam(pageIndex)}`),

    subscribePackageList: (projectId, pageIndex) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/subscribe-package-list${getPageParam(pageIndex)}`),

    transactionAmountTypeList: path(ROOTS_DASHBOARD, '/common-sections/transaction-amount-type-list'),
    subscribePackageTypeList: path(ROOTS_DASHBOARD, '/common-sections/package-type-list'),
    subscribePackagePositionList: path(ROOTS_DASHBOARD, '/common-sections/package-position-list'),
    notificationStyleList: path(ROOTS_DASHBOARD, '/common-sections/notification-style-list'),
    productType: path(ROOTS_DASHBOARD, '/common-sections/product-type'),

    notificationPopupList: (projectId, pageIndex) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/notification-popup-list${getPageParam(pageIndex)}`),

    contentManager: (pageIndex) => path(ROOTS_DASHBOARD, `/content-manager${getPageParam(pageIndex)}`),
    contentCreateForm: path(ROOTS_DASHBOARD, '/content-manager/new-content'),
    manageContent: (mediaId) => path(ROOTS_DASHBOARD, `/content-manager/contents/${mediaId}/manage-content`),

    wikiMediaInfo: (mediaId) => path(ROOTS_DASHBOARD, `/content-manager/${mediaId}/wiki-media-info`),
    wikiMediaCreateForm: (mediaId) => path(ROOTS_DASHBOARD, `/content-manager/${mediaId}/new-wiki-media`),
    wikiMediaEditForm: (mediaId, wikiMediaId) =>
      path(ROOTS_DASHBOARD, `/content-manager/contents/${mediaId}/wiki-medias/${wikiMediaId}/edit`),
    gamesList: (pageIndex) => path(ROOTS_DASHBOARD, `/games-manager/games-list${getPageParam(pageIndex)}`),

    gameManagement: (gameId) => path(ROOTS_DASHBOARD, `/games-manager/${gameId}/manage-game`),

    duelList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/duels${getPageParam(pageIndex)}`),
    leaderBoardList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/leaderboards${getPageParam(pageIndex)}`),

    // notificationBannerTypeList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/banners${getPageParam(pageIndex)}`),
    notificationBannerTypeList: (projectId) => path(ROOTS_DASHBOARD, `/project/${projectId}/notification-group-type-list/`),
    notificationBannerList: (projectId, bannerType) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/notification-group-type-list/${bannerType}`),

    subscribers: (projectId) => path(ROOTS_DASHBOARD, `/project/${projectId}/subscribers/`),

    commentList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/comment-list${getPageParam(pageIndex)}`),

    // ----------------------------------------------------------------------------------------------------------------

    gamePlayList: (pageIndex) => path(ROOTS_DASHBOARD, `/game-playlist${getPageParam(pageIndex)}`),

    gameJoinList: (gamePlaylistId, pageIndex) =>
      path(ROOTS_DASHBOARD, `/game-playlist/${gamePlaylistId}/game-join-list${getPageParam(pageIndex)}`),

    // ----------------------------------------------------------------------------------------------------------------

    mediaGroupTypeList: path(ROOTS_DASHBOARD, '/media-group-type-list'),

    mediaGroupList: (mediaGroupTypeId, pageIndex) =>
      path(ROOTS_DASHBOARD, `/media-group-list/${mediaGroupTypeId}/${getPageParam(pageIndex)}`),

    mediaGroupItemList: (mediaGroupTypeId, mediaGroupId, pageIndex) =>
      path(ROOTS_DASHBOARD, `/media-group-list/${mediaGroupTypeId}/${mediaGroupId}/media-group-item-list${getPageParam(pageIndex)}`),

    // ----------------------------------------------------------------------------------------------------------------

    gameFeeList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/game-fee-list${getPageParam(pageIndex)}`),

    exchangeList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/exchange-list${getPageParam(pageIndex)}`),

    gameEntryFeeRewards: (projectId, pageIndex) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/game-entry-fee-rewards${getPageParam(pageIndex)}`),
    avatarList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/avatar-list${getPageParam(pageIndex)}`),

    manageAppVersionControl: (pageIndex) => path(ROOTS_DASHBOARD, `/app-version-control-list${getPageParam(pageIndex)}`),

    // gameServiceReport: path(ROOTS_DASHBOARD, '/game-service-report'),

    // ----------------------------------------------------------------------------------------------------------------

    myProfile: path(ROOTS_DASHBOARD, '/my-profile'),

    userList: (pageIndex) => path(ROOTS_DASHBOARD, `/user-list${getPageParam(pageIndex)}`),
    editUser: (userId) => path(ROOTS_DASHBOARD, `/user-list/${userId}/edit-user`),

    adsList: path(ROOTS_DASHBOARD, '/ads-list'),
    adsCreate: path(ROOTS_DASHBOARD, '/ads-list/new-ads'),
    adsEdit: (adsId) => path(ROOTS_DASHBOARD, `/ads-list/${adsId}/edit-ads`),

    // ----------------------------------------------------------------------------------------------------------------

    transactionPackageList: (projectId, pageIndex) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/transaction-package-list${getPageParam(pageIndex)}`),

    // ----------------------------------------------------------------------------------------------------------------

    rtmpList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/rtmp-list${getPageParam(pageIndex)}`),

    rtmpAppList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/rtmp-app-list${getPageParam(pageIndex)}`),

    // ----------------------------------------------------------------------------------------------------------------

    landingList: (pageIndex) => path(ROOTS_DASHBOARD, `/landing-list${getPageParam(pageIndex)}`),

    uploadToServerList: (pageIndex) => path(ROOTS_DASHBOARD, `/upload-to-server/list${getPageParam(pageIndex)}`),
    uploadToServerCreate: path(ROOTS_DASHBOARD, '/upload-to-server/list/new'),

    appSectionList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/app-sections${getPageParam(pageIndex)}`),

    appSectionBannersList: (projectId, sectionKeyOrder, pageIndex) =>
      path(ROOTS_DASHBOARD, `/project/${projectId}/app-sections/${sectionKeyOrder}/bannersList${getPageParam(pageIndex)}`),

    profileRewardList: (projectId, pageIndex) => path(ROOTS_DASHBOARD, `/project/${projectId}/profile-reward${getPageParam(pageIndex)}`),

    dailyTrafficReport: path(ROOTS_DASHBOARD, '/daily-traffic-report'),
    trafficReport: path(ROOTS_DASHBOARD, '/traffic-report'),

    manageMetaData: path(ROOTS_DASHBOARD, '/metadata-management'),

    home: path(ROOTS_DASHBOARD, '/home'),

    // ----------------------------------------------------------------------------------------------------------------

    financialReports: path(ROOTS_DASHBOARD, `/financial-management/reports`),

    gatewayList: (pageIndex) => path(ROOTS_DASHBOARD, `/financial-management/gateway-list${getPageParam(pageIndex)}`),

    gatewayProfileList: (pageIndex) => path(ROOTS_DASHBOARD, `/financial-management/gateway-profile-list${getPageParam(pageIndex)}`),
    gatewayProfileCreate: path(ROOTS_DASHBOARD, '/financial-management/gateway-profile-list/new-gateway-profile'),
    gatewayProfileEdit: (gatewayProfileId) =>
      path(ROOTS_DASHBOARD, `/financial-management/gateway-profile-list/${gatewayProfileId}/edit-gateway-profile`),

    gatewayJoinProfileList: (pageIndex) =>
      path(ROOTS_DASHBOARD, `/financial-management/gateway-join-profile-list${getPageParam(pageIndex)}`),

    // ----------------------------------------------------------------------------------------------------------------

    // Footballop

    gameCardList: (pageIndex) => path(ROOTS_DASHBOARD, `/footballop/game-card-list${getPageParam(pageIndex)}`),

    gamePlanetList: (pageIndex) => path(ROOTS_DASHBOARD, `/footballop/game-planet-list${getPageParam(pageIndex)}`),
    gamePlanetCreate: path(ROOTS_DASHBOARD, '/footballop/game-planet-list/new-game-planet'),
    gamePlanetEdit: (gamePlanetId) => path(ROOTS_DASHBOARD, `/footballop/game-planet-list/${gamePlanetId}/edit-game-planet`),

    giftCodeList: (pageIndex) => path(ROOTS_DASHBOARD, `/footballop/gift-code-list${getPageParam(pageIndex)}`),
    giftCodeCreate: path(ROOTS_DASHBOARD, '/footballop/gift-code-list/new-gift-code'),
    giftCodeEdit: (giftCodeId) => path(ROOTS_DASHBOARD, `/footballop/gift-code-list/${giftCodeId}/edit-gift-code`),

    // ----------------------------------------------------------------------------------------------------------------

    // social manager

    socialManagerAccountList: (pageIndex) => path(ROOTS_DASHBOARD, `/social-manager/account-list${getPageParam(pageIndex)}`),

    socialManagerContentList: (pageIndex) => path(ROOTS_DASHBOARD, `/social-manager/content-list${getPageParam(pageIndex)}`),

    socialManagerChannelList: (pageIndex) => path(ROOTS_DASHBOARD, `/social-manager/channel-list${getPageParam(pageIndex)}`),

    // ----------------------------------------------------------------------------------------------------------------

    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
